module.exports = __webpack_public_path__ + "static/media/france-3-hauts-de-france.2c8f9c86.svg";